/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szme042aResponseDryrskInfDto { 
    /**
     * 請求お客さま番号：数字
     */
    recptFixNo: string;
    /**
     * サービス契約番号：数字
     */
    srvCtrNo: string;
    /**
     * 契約お客さま番号：数字
     */
    firstSrvctrNo: string;
    /**
     * 延滞利息金額：数字
     */
    delayRisoku: number;
    /**
     * 対象金額：数字
     */
    targetMny: number;
    /**
     * 対象消費税金額：数字
     */
    targetCsptaxMny: number;
    /**
     * 延滞利息計算対象期間日数：数字
     */
    tgtkiDaycnt?: number;
    /**
     * 支払期限日付：日付(yyyyMMdd)
     */
    payDlineDate?: string;
    /**
     * 延滞利息請求猶予期限日付：日付(yyyyMMdd)
     */
    dryrskClgrltDate?: string;
    /**
     * 支払期限日基準日付：日付(yyyyMMdd)
     */
    pydlndStdday?: string;
    /**
     * 領収金額：数字<br>　【領収金．領収金入金金額】または【売掛金入金．売掛金入金金額】
     */
    rcvMny?: number;
    /**
     * 領収日付：日付(yyyyMMdd)
     */
    rcvDate?: string;
    /**
     * 売掛金番号：数字<br>　【延滞利息．売掛金番号】
     */
    cdtmnyNo: string;
    /**
     * 売掛金履歴番号：数字<br>　【延滞利息．売掛金履歴番号】
     */
    cdtmnyRrkno: string;
    /**
     * 売掛金入金履歴番号：数字<br>　【延滞利息．売掛金入金履歴番号】
     */
    cdtmnyRcvmnyRrkno: string;
    /**
     * 請求料金請求計上年月：日付(yyyyMM)<br>　【延滞利息．請求料金請求計上年月】
     */
    claimCalcYmt: string;
}

